var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChannels = function SvgChannels(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 23,
    fill: "none",
    viewBox: "0 0 20 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14.354.232a1 1 0 0 1 .128 1.408L10.85 6h7.475C19.25 6 20 6.75 20 7.676v10.648C20 19.25 19.25 20 18.324 20H1.675C.75 20 0 19.25 0 18.324V7.676C0 6.75.75 6 1.675 6h6.196L5.293 3.42a1 1 0 1 1 1.414-1.414L9.36 4.661 12.946.36a1 1 0 0 1 1.408-.128M2 8v10h16V8z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.344 22a1 1 0 0 1 1-1h7.593a1 1 0 0 1 0 2H6.344a1 1 0 0 1-1-1"
  })));
};
export default SvgChannels;